/* unplugin-vue-components disabled */import { render } from "./TipDialog.vue?vue&type=template&id=92621932&scoped=true"
import script from "./TipDialog.vue?vue&type=script&lang=js"
export * from "./TipDialog.vue?vue&type=script&lang=js"

import "./TipDialog.vue?vue&type=style&index=0&id=92621932&lang=scss"
import "./TipDialog.vue?vue&type=style&index=1&id=92621932&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92621932"]])

export default __exports__